module.exports = __webpack_public_path__ + "img/ico-contract-b.3a1ac4fd.svg";